import { TabPanel } from "@mui/lab"
import { EvidenceTab } from "../../components/evidenceTab"
import { useStyles } from "./styles"
import { RightProps } from "./type"
import { EvidenceTabEnum } from "../../enum"
import { DetailKeyValue, SnackSimple } from "../../../../../../components"
import { Box, Button } from "@mui/material"
import EvidenceDetail from "../../components/evidenceDetail"
import { NoResponse } from "../../../../../../components/errors/noResponse"
import { useTranslation } from "react-i18next"
import { useAccordions, useEvidenceDownload } from "../../../../../calendar/pages/detail/hooks"

function Right({ items, evidenceDetailProps, evidences, id, /* toggleAccordions, expandAll  */}: RightProps) {
    const { t } = useTranslation()
    const styles = useStyles()

    const { disable, openSnackbar, handleCloseSnackbar, downloadEvidences } = useEvidenceDownload(`evidencias de plan de ación ${id}`, evidences);



    return (
        <Box sx={styles.background}>
            <SnackSimple close={handleCloseSnackbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} />
            <Box sx={styles.containerEvidence}>
                <EvidenceTab
                    tabList={[{ label: 'actionPlan.tabs.item', value: EvidenceTabEnum.ITEM }, { label: 'actionPlan.tabs.evidence', value: EvidenceTabEnum.EVIDENCE }]}
                >
                    <TabPanel value={EvidenceTabEnum.ITEM}>
                        <Box sx={styles.container}>
                            {!!items?.length && items?.map(item => (
                                <DetailKeyValue key={item.id} sxContainer={styles.detailItem} value={item.answer} caption={item.question} />
                            ))}
                            {
                                !items?.length && <NoResponse label={t('reportFolio.detail.general.noInformation')} />
                            }
                        </Box>
                    </TabPanel>

                    <TabPanel sx={styles.tab} value={EvidenceTabEnum.EVIDENCE}>
                        <Box sx={styles.mainContainer}>
                                <EvidenceDetail {...evidenceDetailProps} />
                            { evidenceDetailProps.existEvidences && (
                                <Box>
                                    <Button variant='text_primary' onClick={downloadEvidences} disabled={disable}>{t('schedule.buttons.downloadEvidence')}</Button>
                                </Box>
                            )}
                        </Box>
                    </TabPanel>
                </EvidenceTab>
            </Box>
        </Box>
    )
}

export default Right